/** @deprecated - this is moved to libs */
export enum RelationCode {
    Partner = 'PRTR',
    Child = 'KIND',
    Owner = 'IKZE'
}
